import React from 'react'
import { Box, Typography } from '@material-ui/core'

import { ChatHeaderActions, ChatSuggestions } from './components'

import useAuth from 'hooks/useAuth'
import useDaiChat from 'hooks/useDaiChat'

import daiStarLogoBlue from 'images/dai-star-logo-blue.png'
import useStyles from './styles'
import theme from 'theme'

const ChatHeader = ({ chatSize }) => {
  const classes = useStyles()
  const { user } = useAuth()
  const { hasMessage } = useDaiChat()

  const userName = () => {
    try {
      return user.name.split(' ')[0]
    } catch (error) {
      return 'Usuário'
    }
  }

  return (
    <Box>
      <Box className={classes.chatHeader}>
        <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
          <img
            src={daiStarLogoBlue}
            alt="Dai Star Logo"
            className={classes.daiLogo}
          />
          <Typography variant="caption" className={classes.previewChip}>
            PREVIEW
          </Typography>
        </Box>

        <ChatHeaderActions chatSize={chatSize} />
      </Box>

      {!hasMessage && (
        <Box>
          <Typography
            variant="h3"
            className={classes.chatIntroductionFirstMessage}
          >
            Olá {userName()},
          </Typography>
          <Typography variant="h5" color="textPrimary" gutterBottom>
            sou a DAI, sua assistente virtual.
          </Typography>
          <Typography variant="h3" color="secondary">
            Como posso ajudar?
          </Typography>

          <ChatSuggestions />
        </Box>
      )}
    </Box>
  )
}

export default ChatHeader
